/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetStripeCustomerQueryVariables = Types.Exact<{
  input: Types.StripeCustomerInput;
}>;


export type GetStripeCustomerQuery = { __typename?: 'Query', getStripeCustomer: { __typename?: 'StripeCustomer', customerId: string, name?: string | null, currency?: string | null, address?: { __typename?: 'StripeAddress', line1?: string | null, line2?: string | null, city?: string | null, country?: string | null, postal_code?: string | null, state?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', brand: string, last4: string, exp_month: number, exp_year: number } | null, nextPayment?: { __typename?: 'NextPayment', amount?: number | null, date?: number | null, currency?: string | null } | null } };

export type GetListStripeInvoicesQueryVariables = Types.Exact<{
  input: Types.StripeCustomerInput;
}>;


export type GetListStripeInvoicesQuery = { __typename?: 'Query', listStripeInvoices: Array<{ __typename?: 'StripeInvoice', id: string, number?: string | null, due_date?: number | null, created: number, status?: string | null, invoice_pdf?: string | null }> };

export type UpdateStripeCustomerMutationVariables = Types.Exact<{
  input: Types.UpdateStripeCustomerModelInput;
}>;


export type UpdateStripeCustomerMutation = { __typename?: 'Mutation', updateStripeCustomer: { __typename?: 'UpdateStripeCustomerResponse', message: string, data?: { __typename?: 'CustomerData', id: string, object: string, balance: number, created: number, currency?: string | null, default_source?: string | null, delinquent?: boolean | null, desciption?: string | null, discount?: number | null, email?: string | null, invoice_prefix?: string | null, livemode: boolean, name?: string | null, phone?: string | null, shipping?: string | null, address?: { __typename?: 'StripeAddress', line1?: string | null, line2?: string | null, city?: string | null, country?: string | null, postal_code?: string | null, state?: string | null } | null } | null } };

export type ValidateCouponQueryVariables = Types.Exact<{
  input: Types.ValidateCouponInput;
}>;


export type ValidateCouponQuery = { __typename?: 'Query', validateCoupon: { __typename?: 'StripeCoupon', amount_off?: number | null, created: number, currency?: string | null, duration: string, duration_inmonths?: number | null, id: string, livemode: boolean, max_redemptions?: number | null, name?: string | null, object: string, percent_off?: number | null, redeem_by?: number | null, times_redeemed: number, valid: boolean } };

export type GetPricesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetPricesQuery = { __typename?: 'Query', getPrices: Array<{ __typename?: 'StripePrice', id: string, object: string, active: boolean, billing_scheme: string, created: number, currency: string, livemode: boolean, product: string, type: Types.PriceType, unit_amount: number, metadata: { __typename?: 'PriceMetadata', planType?: Types.PlanType | null, oneTimeFee?: number | null, pairedPrice?: string | null }, recurring?: { __typename?: 'RecurringData', interval: string, interval_count: number, usage_type: string } | null, currency_options?: Array<{ __typename?: 'CurrencyOptions', currency: string, tax_behavior?: Types.TaxBehavior | null, unit_amount?: number | null, unit_amount_decimal?: string | null, custom_unit_amount?: { __typename?: 'CustomUnitAmount', maximum?: number | null, minimum?: number | null, preset?: number | null } | null, tiers?: Array<{ __typename?: 'Tier', flat_amount?: number | null, flat_amount_decimal?: string | null, unit_amount?: number | null, unit_amount_decimal?: string | null, up_to?: number | null }> | null }> | null }> };

export type GetTaxQueryVariables = Types.Exact<{
  input: Types.GetStripeTaxInput;
}>;


export type GetTaxQuery = { __typename?: 'Query', getTax?: { __typename?: 'TaxRate', id: string, object: string, active: boolean, created: number, description?: string | null, display_name: string, inclusive: boolean, jurisdiction?: string | null, livemode: boolean, percentage: number } | null };


export const GetStripeCustomerDocument = gql`
    query getStripeCustomer($input: StripeCustomerInput!) {
  getStripeCustomer(input: $input) {
    customerId
    name
    currency
    address {
      line1
      line2
      city
      country
      postal_code
      state
    }
    paymentMethod {
      brand
      last4
      exp_month
      exp_year
    }
    nextPayment {
      amount
      date
      currency
    }
  }
}
    `;
export function useGetStripeCustomerQuery(baseOptions: Apollo.QueryHookOptions<GetStripeCustomerQuery, GetStripeCustomerQueryVariables> & ({ variables: GetStripeCustomerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStripeCustomerQuery, GetStripeCustomerQueryVariables>(GetStripeCustomerDocument, options);
      }
export function useGetStripeCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStripeCustomerQuery, GetStripeCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStripeCustomerQuery, GetStripeCustomerQueryVariables>(GetStripeCustomerDocument, options);
        }
// @ts-ignore
export function useGetStripeCustomerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStripeCustomerQuery, GetStripeCustomerQueryVariables>): Apollo.UseSuspenseQueryResult<GetStripeCustomerQuery, GetStripeCustomerQueryVariables>;
export function useGetStripeCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStripeCustomerQuery, GetStripeCustomerQueryVariables>): Apollo.UseSuspenseQueryResult<GetStripeCustomerQuery | undefined, GetStripeCustomerQueryVariables>;
export function useGetStripeCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStripeCustomerQuery, GetStripeCustomerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStripeCustomerQuery, GetStripeCustomerQueryVariables>(GetStripeCustomerDocument, options);
        }
export type GetStripeCustomerQueryHookResult = ReturnType<typeof useGetStripeCustomerQuery>;
export type GetStripeCustomerLazyQueryHookResult = ReturnType<typeof useGetStripeCustomerLazyQuery>;
export type GetStripeCustomerSuspenseQueryHookResult = ReturnType<typeof useGetStripeCustomerSuspenseQuery>;
export type GetStripeCustomerQueryResult = Apollo.QueryResult<GetStripeCustomerQuery, GetStripeCustomerQueryVariables>;
export const GetListStripeInvoicesDocument = gql`
    query getListStripeInvoices($input: StripeCustomerInput!) {
  listStripeInvoices(input: $input) {
    id
    number
    due_date
    created
    status
    invoice_pdf
  }
}
    `;
export function useGetListStripeInvoicesQuery(baseOptions: Apollo.QueryHookOptions<GetListStripeInvoicesQuery, GetListStripeInvoicesQueryVariables> & ({ variables: GetListStripeInvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetListStripeInvoicesQuery, GetListStripeInvoicesQueryVariables>(GetListStripeInvoicesDocument, options);
      }
export function useGetListStripeInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListStripeInvoicesQuery, GetListStripeInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetListStripeInvoicesQuery, GetListStripeInvoicesQueryVariables>(GetListStripeInvoicesDocument, options);
        }
// @ts-ignore
export function useGetListStripeInvoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetListStripeInvoicesQuery, GetListStripeInvoicesQueryVariables>): Apollo.UseSuspenseQueryResult<GetListStripeInvoicesQuery, GetListStripeInvoicesQueryVariables>;
export function useGetListStripeInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetListStripeInvoicesQuery, GetListStripeInvoicesQueryVariables>): Apollo.UseSuspenseQueryResult<GetListStripeInvoicesQuery | undefined, GetListStripeInvoicesQueryVariables>;
export function useGetListStripeInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetListStripeInvoicesQuery, GetListStripeInvoicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetListStripeInvoicesQuery, GetListStripeInvoicesQueryVariables>(GetListStripeInvoicesDocument, options);
        }
export type GetListStripeInvoicesQueryHookResult = ReturnType<typeof useGetListStripeInvoicesQuery>;
export type GetListStripeInvoicesLazyQueryHookResult = ReturnType<typeof useGetListStripeInvoicesLazyQuery>;
export type GetListStripeInvoicesSuspenseQueryHookResult = ReturnType<typeof useGetListStripeInvoicesSuspenseQuery>;
export type GetListStripeInvoicesQueryResult = Apollo.QueryResult<GetListStripeInvoicesQuery, GetListStripeInvoicesQueryVariables>;
export const UpdateStripeCustomerDocument = gql`
    mutation updateStripeCustomer($input: UpdateStripeCustomerModelInput!) {
  updateStripeCustomer(input: $input) {
    message
    data {
      id
      object
      address {
        line1
        line2
        city
        country
        postal_code
        state
      }
      balance
      created
      currency
      default_source
      delinquent
      desciption
      discount
      email
      invoice_prefix
      livemode
      name
      phone
      shipping
    }
  }
}
    `;
export type UpdateStripeCustomerMutationFn = Apollo.MutationFunction<UpdateStripeCustomerMutation, UpdateStripeCustomerMutationVariables>;
export function useUpdateStripeCustomerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStripeCustomerMutation, UpdateStripeCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStripeCustomerMutation, UpdateStripeCustomerMutationVariables>(UpdateStripeCustomerDocument, options);
      }
export type UpdateStripeCustomerMutationHookResult = ReturnType<typeof useUpdateStripeCustomerMutation>;
export type UpdateStripeCustomerMutationResult = Apollo.MutationResult<UpdateStripeCustomerMutation>;
export type UpdateStripeCustomerMutationOptions = Apollo.BaseMutationOptions<UpdateStripeCustomerMutation, UpdateStripeCustomerMutationVariables>;
export const ValidateCouponDocument = gql`
    query validateCoupon($input: ValidateCouponInput!) {
  validateCoupon(input: $input) {
    amount_off
    created
    currency
    duration
    duration_inmonths
    id
    livemode
    max_redemptions
    name
    object
    percent_off
    redeem_by
    times_redeemed
    valid
  }
}
    `;
export function useValidateCouponQuery(baseOptions: Apollo.QueryHookOptions<ValidateCouponQuery, ValidateCouponQueryVariables> & ({ variables: ValidateCouponQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateCouponQuery, ValidateCouponQueryVariables>(ValidateCouponDocument, options);
      }
export function useValidateCouponLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateCouponQuery, ValidateCouponQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateCouponQuery, ValidateCouponQueryVariables>(ValidateCouponDocument, options);
        }
// @ts-ignore
export function useValidateCouponSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateCouponQuery, ValidateCouponQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateCouponQuery, ValidateCouponQueryVariables>;
export function useValidateCouponSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateCouponQuery, ValidateCouponQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateCouponQuery | undefined, ValidateCouponQueryVariables>;
export function useValidateCouponSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateCouponQuery, ValidateCouponQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateCouponQuery, ValidateCouponQueryVariables>(ValidateCouponDocument, options);
        }
export type ValidateCouponQueryHookResult = ReturnType<typeof useValidateCouponQuery>;
export type ValidateCouponLazyQueryHookResult = ReturnType<typeof useValidateCouponLazyQuery>;
export type ValidateCouponSuspenseQueryHookResult = ReturnType<typeof useValidateCouponSuspenseQuery>;
export type ValidateCouponQueryResult = Apollo.QueryResult<ValidateCouponQuery, ValidateCouponQueryVariables>;
export const GetPricesDocument = gql`
    query getPrices {
  getPrices {
    id
    object
    active
    billing_scheme
    created
    currency
    livemode
    metadata {
      planType
      oneTimeFee
      pairedPrice
    }
    product
    recurring {
      interval
      interval_count
      usage_type
    }
    type
    unit_amount
    currency_options {
      currency
      custom_unit_amount {
        maximum
        minimum
        preset
      }
      tax_behavior
      tiers {
        flat_amount
        flat_amount_decimal
        unit_amount
        unit_amount_decimal
        up_to
      }
      unit_amount
      unit_amount_decimal
    }
  }
}
    `;
export function useGetPricesQuery(baseOptions?: Apollo.QueryHookOptions<GetPricesQuery, GetPricesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPricesQuery, GetPricesQueryVariables>(GetPricesDocument, options);
      }
export function useGetPricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPricesQuery, GetPricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPricesQuery, GetPricesQueryVariables>(GetPricesDocument, options);
        }
// @ts-ignore
export function useGetPricesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPricesQuery, GetPricesQueryVariables>): Apollo.UseSuspenseQueryResult<GetPricesQuery, GetPricesQueryVariables>;
export function useGetPricesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPricesQuery, GetPricesQueryVariables>): Apollo.UseSuspenseQueryResult<GetPricesQuery | undefined, GetPricesQueryVariables>;
export function useGetPricesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPricesQuery, GetPricesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPricesQuery, GetPricesQueryVariables>(GetPricesDocument, options);
        }
export type GetPricesQueryHookResult = ReturnType<typeof useGetPricesQuery>;
export type GetPricesLazyQueryHookResult = ReturnType<typeof useGetPricesLazyQuery>;
export type GetPricesSuspenseQueryHookResult = ReturnType<typeof useGetPricesSuspenseQuery>;
export type GetPricesQueryResult = Apollo.QueryResult<GetPricesQuery, GetPricesQueryVariables>;
export const GetTaxDocument = gql`
    query getTax($input: GetStripeTaxInput!) {
  getTax(input: $input) {
    id
    object
    active
    created
    description
    display_name
    inclusive
    jurisdiction
    livemode
    percentage
  }
}
    `;
export function useGetTaxQuery(baseOptions: Apollo.QueryHookOptions<GetTaxQuery, GetTaxQueryVariables> & ({ variables: GetTaxQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxQuery, GetTaxQueryVariables>(GetTaxDocument, options);
      }
export function useGetTaxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxQuery, GetTaxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxQuery, GetTaxQueryVariables>(GetTaxDocument, options);
        }
// @ts-ignore
export function useGetTaxSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaxQuery, GetTaxQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaxQuery, GetTaxQueryVariables>;
export function useGetTaxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaxQuery, GetTaxQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaxQuery | undefined, GetTaxQueryVariables>;
export function useGetTaxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaxQuery, GetTaxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaxQuery, GetTaxQueryVariables>(GetTaxDocument, options);
        }
export type GetTaxQueryHookResult = ReturnType<typeof useGetTaxQuery>;
export type GetTaxLazyQueryHookResult = ReturnType<typeof useGetTaxLazyQuery>;
export type GetTaxSuspenseQueryHookResult = ReturnType<typeof useGetTaxSuspenseQuery>;
export type GetTaxQueryResult = Apollo.QueryResult<GetTaxQuery, GetTaxQueryVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useGetStripeCustomer = withQueryResponseHandler(useGetStripeCustomerQuery);
export const useGetListStripeInvoices = withQueryResponseHandler(useGetListStripeInvoicesQuery);
export const useValidateCoupon = withQueryResponseHandler(useValidateCouponQuery);
export const useGetPrices = withQueryResponseHandler(useGetPricesQuery);
export const useGetTax = withQueryResponseHandler(useGetTaxQuery);
export const useUpdateStripeCustomer = withMutationResponseHandler(useUpdateStripeCustomerMutation, "updateStripeCustomer");